import { useDynamicLocation } from "apps/commons/hooks/useDynamicLocation";
import { useEffect } from "react";
import { sendPerformanceMetric } from "./performanceClient";

export const usePerformanceMetric = () => {
    const { pathname } = useDynamicLocation();
    useEffect(() => {
        sendPerformanceMetric({ pathname });
    }, [pathname]);
};
